import { render, staticRenderFns } from "./ImportProductsList.vue?vue&type=template&id=72c933a1&scoped=true"
import script from "./ImportProductsList.vue?vue&type=script&lang=js"
export * from "./ImportProductsList.vue?vue&type=script&lang=js"
import style0 from "./ImportProductsList.vue?vue&type=style&index=0&id=72c933a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c933a1",
  null
  
)

export default component.exports